import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import BoardsCarouselComponent from "./boards-carousel/boards-carousel-component";
import { StyledBoardsAndQoutesCarouselComponent } from "./boards-and-quotes-carousel-component.scss";
class BoardsAndQoutesCarouselComponent extends PureComponent {
    componentWillReceiveProps(nextProps) {
        if (nextProps.activeIndex != this.state.active) {
            this.setState({
                active: nextProps.activeIndex
            });
        }
    }
    setActive(active) {
        const { setActive } = this.props;
        if (setActive) {
            setActive(active);
        } else {
            this.setState({
                active
            });
        }
    }
    render() {
        const { quotes, stopAutoSlide, startAutoSlide, showNavigationArrows, removeBoardBorder, aboveTheFold } = this.props;
        const active = Math.min(quotes.length - 1, this.state.active);
        if (!quotes[active]) return false;
        return /*#__PURE__*/ _jsx(StyledBoardsAndQoutesCarouselComponent, {
            className: "boards-and-quotes-carousel-component",
            children: /*#__PURE__*/ _jsx("div", {
                className: "boards-carousel-wrapper",
                children: /*#__PURE__*/ _jsx(BoardsCarouselComponent, {
                    quotes: quotes,
                    active: active,
                    setActive: this.setActive,
                    stopAutoSlide: stopAutoSlide,
                    startAutoSlide: startAutoSlide,
                    showNavigationArrows: showNavigationArrows,
                    removeBoardBorder: removeBoardBorder,
                    aboveTheFold: aboveTheFold
                })
            })
        });
    }
    constructor(props){
        super(props);
        this.state = {
            active: 0
        };
        this.setActive = this.setActive.bind(this);
    }
}
export { BoardsAndQoutesCarouselComponent as default };
BoardsAndQoutesCarouselComponent.defaultProps = {
    quotes: []
};
